module.exports = __webpack_public_path__ + "static/img/1.2811119.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/8/zh/1.png
// module id = QX8G
// module chunks = 0